/** PURE_IMPORTS_START  PURE_IMPORTS_END */
"use strict";
/*@__PURE__*/ Object.defineProperty(exports, "__esModule", { value: true });
var async_1 = /*@__PURE__*/ require("../scheduler/async");
var map_1 = /*@__PURE__*/ require("./map");
function timestamp(scheduler) {
    if (scheduler === void 0) {
        scheduler = async_1.async;
    }
    return map_1.map(function (value) { return new Timestamp(value, scheduler.now()); });
}
exports.timestamp = timestamp;
var Timestamp = /*@__PURE__*/ (function () {
    function Timestamp(value, timestamp) {
        this.value = value;
        this.timestamp = timestamp;
    }
    return Timestamp;
}());
exports.Timestamp = Timestamp;
